module.exports = __webpack_public_path__ + "img/merchandise_icon.69a9408d.png";